// extracted by mini-css-extract-plugin
module.exports = {"container":"CreateStrategyMain_container__2mgeT","emptyBox":"CreateStrategyMain_emptyBox__1x0sN"};